import {Box, Button, Grid, Typography} from "@mui/material";
import iconYellow from "../../assets/skolenie_ikona_orangeyellow.svg";
import {fontType} from "../../constants/font";

function CourseBox({
    course,
    courseData,
    group
}) {
    let icon = iconYellow;
    let titleColor = '#7b7cd5';
    let textColor = '#1d1a56';
    let backgroundColor = 'white';
    let buttonColor = '#7b7cd5';
    let buttonBorderColor = '#7b7cd5';

    if (['beginner', 'itSpecialists'].includes(group)) {
        icon = iconYellow;
        titleColor = 'white';
        textColor = 'white';
        backgroundColor = '#7b7cd5';
        buttonColor = '#f6961d';
        buttonBorderColor = 'white';
    } else if (['advanced', 'agile'].includes(group)) {
        icon = iconYellow;
        titleColor = '#f6961d';
        textColor = 'white';
        backgroundColor = '#1d1a56';
        buttonColor = '#f6961d';
        buttonBorderColor = 'white';
    }

    function renderPrice() {
        return (
            <Box sx={{ display: "flex"}}>
                {course.showPrice ?
                    (
                        <>
                            <Typography
                                sx={{
                                    fontFamily: fontType.bold,
                                    fontSize: 32,
                                    lineHeight: "36px",
                                    color: textColor,
                                    textAlign: "center",
                                }}
                            >
                                {courseData?.price} €
                            </Typography>
                            <Typography
                                sx={{
                                    fontFamily: fontType.regular,
                                    fontSize: 16,
                                    marginTop: "2px",
                                    marginLeft: "6px",
                                    lineHeight: "36px",
                                    color: textColor,
                                    textAlign: "center",
                                }}
                            >
                                bez DPH
                            </Typography>
                        </>

                    ) :
                    (
                        <Typography
                            sx={{
                                fontFamily: fontType.bold,
                                fontSize: 22,
                                lineHeight: "36px",
                                color: textColor,
                                textAlign: "center",
                            }}
                        >
                            {course.isPractice ? "ZADARMO" : "Na požiadanie"}
                        </Typography>
                    )
                }
            </Box>
        )
    }
    
    function renderCourseDetailButton() {
        return (
            <Button
                href={(course?.type === 'ISTQB' ? '/skolenia/istqb/' : '/skolenie/') + courseData?.id}
                sx={{
                    borderRadius: "28px",
                    border: "2px solid",
                    borderColor: buttonBorderColor,
                    fontFamily: fontType.regular,
                    fontSize: 16,
                    cursor: "pointer",
                    color: textColor,
                    height: "44px",
                    width: "186px",
                    textTransform: "initial",
                    "&:hover": {
                        backgroundColor: buttonColor,
                        borderColor: buttonColor,
                        color: "white",
                    },
                }}
            >
                Viac o školení
            </Button>
        )
    }

    return (
        <Grid
            container
            sx={{
                display: "flex",
                marginTop: "23px",
                width: "100%",
                // Set initial scale
                transform: "scale(1)",
                transition: "transform 0.3s ease",
                "&:hover": {
                    // Styles on hover
                    transform: "scale(1.1)",
                },
            }}
        >
            <Box
                sx={{
                    width: "100%",
                    backgroundColor: backgroundColor,
                    borderRadius: "20px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <Box
                    sx={{
                        width: "100%",
                        display: 'flex',
                        flexDirection: {xs: 'column', md: 'row'},
                        alignItems: {xs: 'center', md: 'left'}
                    }}
                >
                    <Box
                        sx={{
                            flex: 1,
                            padding: '20px',
                        }}
                    >
                        <Box
                            sx={{
                                width: "77px",
                                height: "77px",
                                display: "flex",
                                position: "relative",
                                justifyContent: "center",
                                alignItems: "center",
                            }}
                        >
                            <img
                                src={icon}
                                alt="student_hat"
                                style={{
                                    height: "150px",
                                    marginBottom: "15px",
                                }}
                            />
                        </Box>
                    </Box>

                    <Box
                        sx={{
                            flex: {sm: 7, md: 8, lg: 9},
                            padding: '20px',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center'
                        }}
                    >
                        <Typography
                            sx={{
                                fontFamily: fontType.medium,
                                fontSize: 22,
                                color: titleColor,
                                lineHeight: "26px",
                                textAlign: {xs: 'center', md: 'left'}
                            }}
                        >
                            {courseData?.name}
                        </Typography>
                        <Typography
                            sx={{
                                fontFamily: fontType.medium,
                                fontSize: 22,
                                color: titleColor,
                                lineHeight: "26px",
                                textAlign: {xs: 'center', md: 'left'}
                            }}
                        >
                            {courseData?.duration_text}
                        </Typography>
                    </Box>

                    <Box
                        sx={{
                            display: {xs: 'none', md: 'block'},
                            flex: {sm: 4, md: 3, xl: 2},
                            padding: '10px',
                            paddingTop: '20px'
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: 'center',
                                flexDirection: "column",
                                marginRight: '10px'
                            }}
                        >
                            { renderPrice() }
                            { renderCourseDetailButton() }
                        </Box>
                    </Box>
                </Box>

                <Box
                    sx={{
                        width: "100%",
                        display: 'flex',
                        marginBottom: '20px'
                    }}
                >
                    <Box
                        sx={{
                            flex: 12,
                        }}
                    >
                        <Typography
                            sx={{
                                fontFamily: fontType.regular,
                                fontSize: 18,
                                lineHeight: "22px",
                                color: textColor,
                                marginRight: "25px",
                                marginLeft: "25px",
                                marginBottom: "10px",
                                textAlign: {xs: 'center', md: 'left'}
                            }}
                            dangerouslySetInnerHTML={{ __html: course.description }}
                        >
                        </Typography>
                    </Box>
                </Box>

                <Box
                    sx={{
                        display: {xs: 'flex', md: 'none'},
                        width: "100%",
                    }}
                >
                    <Box
                        sx={{
                            flex: 12,
                            padding: '10px',
                        }}
                    >
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: 'center',
                                flexDirection: "column",
                                marginRight: '0px'
                            }}
                        >
                            { renderPrice() }
                        </Box>
                    </Box>
                </Box>

                <Box
                    sx={{

                        width: "100%",
                        display: {xs: 'flex', md: 'none'},
                        alignItems: 'center',
                        textAlign: 'center',
                    }}
                >
                    <Box
                        sx={{
                            flex: 12,
                            paddingBottom: '20px',
                            marginRight: {xs: '0px', md: '40px'}
                        }}
                    >
                        { renderCourseDetailButton() }
                    </Box>
                </Box>
            </Box>
        </Grid>
    )
}

export default CourseBox;